"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _useAutocomplete = _interopRequireDefault(require("@material-ui/lab/useAutocomplete"));
var _AirplanemodeActive = _interopRequireDefault(require("@material-ui/icons/AirplanemodeActive"));
var _FlightTakeoff = _interopRequireDefault(require("@material-ui/icons/FlightTakeoff"));
var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery"));
var _TextField = _interopRequireDefault(require("../TextField"));
var _ListItem = _interopRequireDefault(require("../ListItem"));
var _ListItemText = _interopRequireDefault(require("../ListItemText"));
var _Listbox = _interopRequireDefault(require("../Listbox"));
var _AutocompleteModal = _interopRequireDefault(require("./AutocompleteModal"));
var _theme = _interopRequireDefault(require("../../theme"));
var _hooks = _interopRequireDefault(require("../FullScreenModal/hooks"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Autocomplete = props => {
  const {
    options = [],
    hideIconOn = [],
    getOptionLabel = option => option.label,
    getInputLabel = option => option.label,
    getSelectedValue = () => {},
    label = 'From',
    noResultsErrorMessage = "We couldn't find the city/airport you entered",
    placeholder = 'Enter airport name or code',
    id = 'ac',
    className,
    acIcon = /*#__PURE__*/_react.default.createElement(_AirplanemodeActive.default, null),
    incomingValue = '',
    InputProps = {
      startAdornment: /*#__PURE__*/_react.default.createElement(_core.Hidden, {
        only: hideIconOn
      }, /*#__PURE__*/_react.default.createElement(_core.InputAdornment, {
        position: "start"
      }, /*#__PURE__*/_react.default.createElement(_FlightTakeoff.default, null)))
    },
    ...others
  } = props;
  const {
    modalProps,
    open: openModal,
    close: closeModal
  } = (0, _hooks.default)({
    background: '#FFF'
  });
  const [defaultValue, setDefaultValue] = (0, _react.useState)(incomingValue);
  const {
    dirty,
    focused,
    getRootProps,
    getInputProps,
    getListboxProps,
    getOptionProps,
    groupedOptions,
    inputValue,
    value
  } = (0, _useAutocomplete.default)({
    id,
    options,
    openOnFocus: true,
    // eslint-disable-next-line
    onChange: (event, selectedValue) => {
      getSelectedValue(selectedValue);
      if (selectedValue) {
        setDefaultValue(getInputLabel(selectedValue));
      } else {
        setDefaultValue('');
      }
    },
    getOptionLabel: getInputLabel
  });
  const hasGroupedOptions = groupedOptions.length > 0;
  const shouldDisplayError = focused && getInputProps().value !== '' && (dirty ? inputValue !== getInputLabel(value) : true) && !hasGroupedOptions;
  const btnOpenModal = (0, _react.useRef)(null);
  const isMobile = (0, _useMediaQuery.default)(_theme.default.breakpoints.down('md'));
  const [modalIsOpen, setModalIsOpen] = (0, _react.useState)(false);
  const closeModalHandler = () => {
    closeModal();
    setModalIsOpen(false);
    btnOpenModal.current.focus();
  };
  const handleOpenModal = () => {
    setModalIsOpen(isMobile);
    if (isMobile) {
      openModal(btnOpenModal);
    }
  };
  const setModalValueHandler = modalValue => {
    setDefaultValue(getInputLabel(modalValue));
    getSelectedValue(modalValue);
  };
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: className
  }, getRootProps(), {
    ref: btnOpenModal
  }), /*#__PURE__*/_react.default.createElement(_TextField.default, (0, _extends2.default)({}, getInputProps(), {
    onChange: event => {
      getInputProps().onChange(event);
      setDefaultValue(event.target.value);
      if (event.target.value === '') {
        getSelectedValue('');
      }
    },
    onClick: handleOpenModal,
    "data-testid": "acTextField",
    label: label,
    placeholder: placeholder,
    InputProps: InputProps
    // eslint-disable-next-line react/jsx-no-duplicate-props
    ,
    inputProps: {
      'data-testid': 'ac'
    },
    helperText: shouldDisplayError && noResultsErrorMessage,
    error: shouldDisplayError,
    title: inputValue || placeholder,
    value: defaultValue
  }, others)), hasGroupedOptions && !isMobile ? /*#__PURE__*/_react.default.createElement(_Listbox.default, getListboxProps(), groupedOptions.map((option, index) => /*#__PURE__*/_react.default.createElement(_ListItem.default, (0, _extends2.default)({
    key: "list-item-".concat(option)
  }, getOptionProps({
    option,
    index
  })), /*#__PURE__*/_react.default.createElement(_ListItemText.default, {
    onClick: () => {
      setDefaultValue(getInputLabel(option));
    }
  }, acIcon, " ", getOptionLabel(option))))) : null, /*#__PURE__*/_react.default.createElement(_AutocompleteModal.default, {
    refitem: btnOpenModal,
    options: options,
    getInputLabel: getInputLabel,
    getOptionLabel: getOptionLabel,
    getSelectedValue: getSelectedValue,
    setModalValue: setModalValueHandler,
    modalProps: modalProps,
    noResultsErrorMessage: noResultsErrorMessage,
    placeholder: placeholder,
    closeModal: closeModalHandler,
    modalIsOpen: modalIsOpen
  }));
};
var _default = exports.default = Autocomplete;